export default {
  // Navbar
  nav_home: 'Home',
  nav_shopping_guide: 'Shopping Guide',
  nav_spreadsheet: 'Spreadsheet',
  nav_finds: 'Finds',
  nav_categories: 'Categories',
  nav_guides: 'Guides',
  nav_shipping: 'Shipping',
  nav_qc: 'QC',
  nav_reviews: 'Reviews',
  nav_safety: 'Safety',
  nav_explore: 'Explore Spreadsheet',

  // Hero
  hero_h1: 'CSSBuy Spreadsheet: Find Products, Compare Options & Shop Safer',
  hero_subtitle: 'Find products, links, lists, buying guides, QC information, shipping costs and safety tips in one independent resource about CSSBuy Spreadsheet.',
  hero_cta_primary: 'Explore CSSBuy Spreadsheet',
  hero_cta_secondary: 'View Products & Finds',
  hero_trust_1: 'Independent Resource',
  hero_trust_2: 'Updated Guides',
  hero_trust_3: 'Product Research',
  hero_trust_4: 'Safety Tips',
  hero_search_placeholder: 'Search products, categories, sellers or keywords...',
  hero_search_button: 'Search',

  // What is section
  whatis_h2: 'What is a CSSBuy Spreadsheet?',
  whatis_copy: 'A CSSBuy Spreadsheet is a practical way to organize products, links, categories, sellers and useful information for research before a purchase. Our goal is to gather relevant information in a simple structure to help you compare options, understand the process and make more informed decisions.',

  // Categories
  categories_h2: 'Explore Popular Categories',
  categories_cta: 'View All Categories',
  cat_shoes: 'Shoes',
  cat_hoodies: 'Hoodies/Sweaters',
  cat_tshirts: 'T-Shirts',
  cat_jackets: 'Jackets',
  cat_pants: 'Pants/Shorts',
  cat_bags: 'Bags',
  cat_accessories: 'Accessories',
  cat_sportswear: 'Sportswear',
  cat_streetwear: 'Streetwear',
  cat_headwear: 'Headwear',
  cat_sets: 'Sets',
  cat_underwear: 'Underwear',
  cat_jersey: 'Jersey',
  cat_belts: 'Belts',
  cat_perfumes: 'Perfumes',
  cat_other: 'Other Stuff',

  // Finds
  finds_h2: 'Latest CSSBuy Finds',
  finds_sub: 'Discover popular products and resources organized to simplify your research.',
  finds_table_product: 'Product',
  finds_table_category: 'Category',
  finds_table_source: 'Source',
  finds_table_info: 'Information',
  finds_table_updated: 'Updated',
  finds_table_view: 'View',
  finds_cta: 'Explore All Finds',

  // Guides
  guides_h2: 'Most Searched CSSBuy Guides',
  guide_review: 'CSSBuy Review',
  guide_shipping: 'CSSBuy Shipping Cost',
  guide_qc: 'CSSBuy QC',
  guide_warehouse: 'CSSBuy Warehouse',
  guide_coupon: 'CSSBuy Coupon',
  guide_discount: 'CSSBuy Discount Code',

  // Comparison
  comparison_h2: 'Compare CSSBuy with Other Platforms',

  // Safety
  safety_h2: 'CSSBuy Safety Center',
  safety_copy: 'Learn how to check links, analyze sellers, understand QC photos, protect your data, recognize fake pages and assess potential risks before placing an order.',
  safety_cta: 'Visit Safety Center',

  // Final CTA
  final_cta_h2: 'Ready to Find Your Next CSSBuy Spreadsheet?',
  final_cta_primary: 'Explore CSSBuy Spreadsheet',
  final_cta_secondary: 'Visit Main Website',

  // Disclaimer
  disclaimer: 'This is an independent informational resource and is not affiliated with CSSBuy. Always verify prices, shipping costs, policies, sellers and current information on the official platform before making a purchase.',

  // Footer
  footer_resources: 'Resources',
  footer_spreadsheet: 'CSSBuy Spreadsheet',
  footer_finds: 'Finds',
  footer_categories: 'Categories',
  footer_guides: 'Guides',
  footer_shipping: 'Shipping',
  footer_qc: 'QC',
  footer_reviews: 'Reviews',
  footer_comparisons: 'Comparisons',
  footer_safety: 'Safety',
  footer_company: 'Company',
  footer_about: 'About',
  footer_contact: 'Contact',
  footer_privacy: 'Privacy Policy',
  footer_terms: 'Terms of Use',
  footer_disclaimer: 'Disclaimer',
  footer_editorial: 'Editorial Policy',
  footer_language: 'Language',
  footer_lang_pt: 'Português',
  footer_lang_de: 'Deutsch',
  footer_lang_en: 'English',
  footer_copyright: '© 2026 CSSBuy Spreadsheet Resource. Independent Resource.',
  footer_main_site: 'Main Website',

  // Article page
  article_breadcrumb_home: 'Home',
  article_breadcrumb_guides: 'Guides',
  article_reading_time: 'min read',
  article_author: 'CSSBuy Spreadsheet Editorial',
  article_published: 'Published',
  article_updated: 'Updated',
  article_toc: 'Table of Contents',
  article_faq: 'Frequently Asked Questions',
  article_related: 'Read Also',
  article_cta: 'Explore More on CSSBuy Spreadsheet',
  article_back_to_home: 'Back to Home',

  // 404
  notfound_title: 'Page Not Found',
  notfound_desc: 'The page you are looking for does not exist. Return to the homepage and continue exploring.',
  notfound_back: 'Back to Home',

  // Meta
  meta_title_home: 'CSSBuy Spreadsheet 2026: Finds, Links & Complete Guide | Independent Resource',
  meta_desc_home: 'Independent resource about CSSBuy Spreadsheet. Find products, buying guides, shipping costs, QC, coupons and safety tips.',
  meta_title_article: 'CSSBuy Spreadsheet Complete Guide 2026: How to Use, Find Products & Buy Safely',
  meta_desc_article: 'Complete and independent guide about CSSBuy Spreadsheet. Learn how to organize products, verify links, research sellers and make safer buying decisions.',

  // Buttons to main site
  btn_main_site: 'CSSBuy Spreadsheet',
  btn_buy_now: 'Buy It Now',
  btn_visit_main: 'Visit Main Website',

  // Category dropdown
  dropdown_label: 'Categories',
  dropdown_all: 'All Categories',

  // Misc
  loading: 'Loading...',
  search: 'Search',
  close: 'Close',
  read_more: 'Read more',
  view_all: 'View all',
  updated: 'Updated',
  independent_resource: 'Independent Resource',
};